import { render, staticRenderFns } from "./CbsRibbon.vue?vue&type=template&id=80f3ef06"
import script from "./CbsRibbon.vue?vue&type=script&lang=js"
export * from "./CbsRibbon.vue?vue&type=script&lang=js"
import style0 from "./CbsRibbon.vue?vue&type=style&index=0&id=80f3ef06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports